import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__base } from '../FIELD__base';
import { REFLECT_METADATA } from '../REFLECT_METADATA';

export function FN_FIELD_CONTAINER__get_metadata_map(target: any) {
  const out: Record<string, REFLECT_METADATA<FIELD__base>> = {};

  // target is the instance, target.constructor is the Class
  let class_current = target.constructor;
  while (class_current && class_current !== Object) {
    const metadata = class_current[CONSTANTS__shared.SYMBOL_METADATA] || {};

    for (const [key, value] of Object.entries(metadata)) {
      if (key in out) continue; // Prevent child class metadata from being overwritten by parent class

      assert_instanceof(value, REFLECT_METADATA<FIELD__base>);
      out[key] = value;
    }

    // Move up the inheritance chain (ChildClass -> BaseClass)
    class_current = Object.getPrototypeOf(class_current);
  }

  return out;
}
